<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form class="form" nzLayout="horizontal" [formGroup]="bipForm">
    <div class="drawer-form-wrapper">
      <div class="form-grid-secondary">
        <nz-form-item>
          <nz-form-label nzFor="studentId" nzRequired>Student ID</nz-form-label>
          <nz-form-control [nzErrorTip]="studentIdErrorTpl">
            <input
              name="studentId"
              type="text"
              nz-input
              id="studentId"
              formControlName="studentId"
              placeholder="Student ID" />
            <ng-template #studentIdErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Student ID is required.
              </ng-container>
              <ng-container *ngIf="control.hasError('studentIdExists')">
                This Student ID already exists. Please check if the student is
                already in the system before creating a new record.
              </ng-container>
              <ng-container *ngIf="control.hasError('pattern')">
                Student ID can only contain letters, numbers, hyphens, and
                underscores.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="studentSchool" nzRequired
            >Student's School</nz-form-label
          >
          <nz-form-control nzErrorTip="Please select student's school.">
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select student's school"
              formControlName="organizationId"
              (nzOnSearch)="onSearchOrganization($event)"
              [nzNotFoundContent]="organizationNotFoundTemplate"
              name="organizationId">
              @for (org of organizationList; track org) {
                <nz-option
                  [nzLabel]="org.organizationName ?? org.value"
                  [nzValue]="org.id"></nz-option>
              }
            </nz-select>
            <ng-template #organizationNotFoundTemplate>
              <div *ngIf="isOrganizationSearchLoading" class="loading-content">
                <span nz-icon nzType="loading" nzSpin></span> Loading...
              </div>
              <div
                *ngIf="
                  !isOrganizationSearchLoading && organizationList.length === 0
                ">
                No schools found
              </div>
              <div
                *ngIf="
                  !isOrganizationSearchLoading && organizationList.length > 0
                ">
                No matching schools found
              </div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="firstName" nzRequired>First Name</nz-form-label>
          <nz-form-control [nzErrorTip]="firstNameErrorTpl">
            <input
              name="first name"
              type="text"
              nz-input
              id="firstName"
              formControlName="firstName"
              placeholder="Enter first name" />
            <ng-template #firstNameErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter first name.
              </ng-container>
              <ng-container *ngIf="control.hasError('minlength')">
                First name must be at least 2 characters.
              </ng-container>
              <ng-container *ngIf="control.hasError('maxlength')">
                First name can not exceed 100 characters.
              </ng-container>
              <ng-container
                *ngIf="
                  control.hasError('pattern') &&
                  !control.hasError('minlength') &&
                  !control.hasError('maxlength')
                ">
                Firstname only contain alphabets and spaces.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="lastName" nzRequired>Last Name</nz-form-label>
          <nz-form-control [nzErrorTip]="lastNameErrorTpl">
            <input
              name="last name"
              type="text"
              nz-input
              id="lastName"
              formControlName="lastName"
              placeholder="Enter last name" />
            <ng-template #lastNameErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter last name.
              </ng-container>
              <ng-container *ngIf="control.hasError('minlength')">
                Last name must be at least 2 characters.
              </ng-container>
              <ng-container *ngIf="control.hasError('maxlength')">
                Last name can not exceed 100 characters.
              </ng-container>
              <ng-container
                *ngIf="
                  control.hasError('pattern') &&
                  !control.hasError('minlength') &&
                  !control.hasError('maxlength')
                ">
                Lastname only contain alphabets and spaces.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="dob" nzRequired>Date of Birth</nz-form-label>
          <nz-form-control nzErrorTip="Please select student's DOB">
            <nz-date-picker
              [nzSuffixIcon]="customSuffix"
              formControlName="dateOfBirth"
              nzPlaceHolder="Select Date"
              nzFormat="MM/dd/yyyy"
              [nzDisabledDate]="disabledDate"
              class="with-suffix"></nz-date-picker>
            <ng-template #customSuffix>
              <svg-icon
                [title]="'Select date'"
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"
                aria-label="Calendar"></svg-icon>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="gender" nzRequired>Gender</nz-form-label>
          <nz-form-control nzErrorTip="Please select gender.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select gender"
              formControlName="genderId"
              name="gender"
              [nzNotFoundContent]="
                genderList.length === 0
                  ? 'No gender options available'
                  : 'No matching gender found'
              "
              [nzShowArrow]="true">
              @for (gender of genderList; track gender) {
                <nz-option
                  [nzLabel]="gender.value"
                  [nzValue]="gender.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="race" nzRequired>Race</nz-form-label>
          <nz-form-control nzErrorTip="Please select race.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select race"
              formControlName="raceId"
              name="race"
              [nzNotFoundContent]="
                raceList.length === 0
                  ? 'No race options available'
                  : 'No matching race found'
              "
              [nzShowArrow]="true">
              @for (race of raceList; track race) {
                <nz-option
                  [nzLabel]="race.value"
                  [nzValue]="race.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="generalEducation">
            General Education
          </nz-form-label>
          <nz-form-control nzErrorTip="Please select general education.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzMode="multiple"
              nzPlaceHolder="Select General Educations"
              name="generalEducations"
              formControlName="generalEducations"
              [nzNotFoundContent]="
                generalEducationList.length === 0
                  ? 'No general education options available'
                  : 'No matching options found'
              "
              [nzShowArrow]="true">
              @for (ge of generalEducationList; track ge) {
                <nz-option [nzLabel]="ge.value" [nzValue]="ge.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="specialEducation">
            Special Education
          </nz-form-label>
          <nz-form-control nzErrorTip="Please select special education.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzMode="multiple"
              nzPlaceHolder="Select Special Educations"
              formControlName="specialEducations"
              name="specialEducations"
              [nzNotFoundContent]="
                specialEducationList.length === 0
                  ? 'No special education options available'
                  : 'No matching options found'
              "
              [nzShowArrow]="true">
              @for (se of specialEducationList; track se) {
                <nz-option [nzLabel]="se.value" [nzValue]="se.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="bipTemplateId" nzRequired>
            BIP Template
          </nz-form-label>
          <nz-form-control nzErrorTip="Please select bip template.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select BIP Template"
              formControlName="bipTemplateId"
              name="bipTemplateId"
              [nzNotFoundContent]="bipTemplateNotFoundTemplate"
              [nzShowArrow]="true">
              @for (template of bipTemplateList; track template) {
                <nz-option
                  [nzLabel]="template.templateName"
                  [nzValue]="template.id"></nz-option>
              }
            </nz-select>
            <ng-template #bipTemplateNotFoundTemplate>
              <div *ngIf="isBipTemplateLoading" class="loading-content">
                <span nz-icon nzType="loading" nzSpin></span> Loading...
              </div>
              <div
                *ngIf="!isBipTemplateLoading && bipTemplateList.length === 0">
                No BIP templates available
              </div>
              <div *ngIf="!isBipTemplateLoading && bipTemplateList.length > 0">
                No matching templates found
              </div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="customScheduleId" nzRequired
            >Student Schedule</nz-form-label
          >
          <nz-form-control nzErrorTip="Please select student schedule.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select student schedule"
              formControlName="customScheduleId"
              name="customScheduleId"
              [nzNotFoundContent]="scheduleNotFoundTemplate"
              [nzShowArrow]="true">
              @for (schedule of customScheduleList; track schedule) {
                <nz-option
                  [nzLabel]="schedule.templateName"
                  [nzValue]="schedule.customScheduleId"></nz-option>
              }
            </nz-select>
            <ng-template #scheduleNotFoundTemplate>
              <div *ngIf="isScheduleLoading" class="loading-content">
                <span nz-icon nzType="loading" nzSpin></span> Loading...
              </div>
              <div
                *ngIf="!isScheduleLoading && customScheduleList.length === 0">
                No schedule templates available
              </div>
              <div *ngIf="!isScheduleLoading && customScheduleList.length > 0">
                No matching schedules found
              </div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="col-span">
          <nz-form-label nzFor="languageLevel" nzRequired>
            <p class="form-desc">
              Select which of the following best describes the vocal language
              skills and ability of the student to understand spoken directions:
            </p>
          </nz-form-label>
          <nz-form-control nzErrorTip="Please select Language Level.">
            <div class="radio-wrapper">
              <nz-radio-group
                id="languageLevel"
                nzName="radiogroup"
                formControlName="languageLevelId"
                class="case-option-wrapper">
                @for (lang of languageLevelList; track lang; let i = $index) {
                  <span nz-radio [nzValue]="lang.id" *ngIf="i < 2">
                    {{
                      i === 0
                        ? 'This student is often unable to verbally express needs/wants or may not usually understand simple spoken directions'
                        : 'This student is usually able to verbally express needs/wants AND usually understand simple spoken directions'
                    }}
                  </span>
                }
              </nz-radio-group>
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="col-span">
          <nz-form-label nzFor="note"> Notes </nz-form-label>
          <nz-form-control [nzErrorTip]="noteErrorTpl">
            <textarea
              id="note"
              name="note"
              rows="4"
              nz-input
              formControlName="note"
              placeholder="Enter your text"></textarea>
            <div class="mt-3 remaining-text">
              {{ bipForm.value.note ? bipForm.value.note.length : 0 }} of 500
              characters used
            </div>
            <ng-template #noteErrorTpl let-control>
              <ng-container *ngIf="control.hasError('maxlength')">
                Note can not exceed 500 characters.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <span
            nz-checkbox
            formControlName="isTrainingStudent"
            (nzCheckedChange)="onTrainingStudentChange($event)">
            Training Student
          </span>
          <span class="hint-text">
            This student will be purged after 14 days
          </span>
        </nz-form-item>
        <nz-form-item>
          <span nz-checkbox formControlName="isEnabledSafetyPlan">
            {{ needSafetyPlanLabel | reportLabel | async }}
          </span>
        </nz-form-item>
      </div>
    </div>
    <div class="display-flex justify-content-between drawer-footer">
      <div class="footer-left">
        <button
          nz-button
          type="button"
          nzType="default"
          (click)="closeDrawer()">
          Cancel
        </button>
      </div>
      <div class="footer-right">
        <button
          nz-button
          type="button"
          nzType="primary"
          [nzLoading]="loading"
          (click)="onSubmit(false)">
          Save & Close
        </button>
        <button
          *ngIf="!isEditMode"
          nz-button
          type="button"
          nzType="primary"
          [nzLoading]="loading"
          (click)="onSubmit(true)">
          Continue to {{ behaviorDetails | reportLabel | async }}
        </button>
      </div>
    </div>
  </form>
</nz-spin>
<nz-modal
  [(nzVisible)]="isTrainingWarningVisible"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="modalFooterTemplate"
  nzWidth="400px"
  nzCentered
  (nzOnCancel)="handleCancelTrainingWarning()">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-warning">
        <svg-icon
          src="/assets/icon/icon-info.svg"
          class="icon s-20"
          aria-label="Info"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Training Student Warning</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        By checking this box, this student case will be permanently deleted from
        all records after 14 days.
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplate>
    <button
      type="button"
      nzBlock
      nz-button
      nzType="primary"
      class="btn btn-confirm"
      (click)="handleCancelTrainingWarning()">
      Confirm
    </button>
  </ng-template>
</nz-modal>
<ng-template #drawerBehaviorTitleTpl>
  <div class="drawer-title-wrapper">
    <div class="back-button">
      <button
        nz-button
        nzType="default"
        type="button"
        (click)="closeBehaviorDrawer()">
        <svg-icon
          src="/assets/icon/icon-arrow.svg"
          class="icon s-20"
          aria-label="Arrow"></svg-icon>
      </button>
    </div>
    <div>
      <h3 class="ant-drawer-title">Define Behavior</h3>
      <nz-breadcrumb nzSeparator=">">
        <nz-breadcrumb-item>
          <span> {{ caseDetail?.student?.firstName }}'s </span>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item
          (click)="closeBehaviorDrawer()"
          (keydown.enter)="closeBehaviorDrawer()">
          <a tabindex="0">Define Behavior</a>
        </nz-breadcrumb-item>
      </nz-breadcrumb>
    </div>
  </div>
</ng-template>
